import { createContext, useContext, useEffect } from "react";

// Controls header text treatment: "overlay" = light text over a dark hero
// (default), "solid" = cream background + dark text for pages with light tops.
export const HeaderThemeContext = createContext({ variant: "overlay", setVariant: () => {} });

export const useHeaderTheme = () => useContext(HeaderThemeContext);

// Pages with a light-colored top call this to force a solid header.
export function useSolidHeader() {
  const { setVariant } = useHeaderTheme();
  useEffect(() => {
    setVariant("solid");
    return () => setVariant("overlay");
  }, [setVariant]);
}
